import { ISelectOption, Select } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';
import { DeviceType } from 'entities/campaign';
import { DeviceClassification } from 'entities/campaign/rules/DeviceType';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<DeviceType>;

export const Form: React.FC<FormProps> = props => {
  const items = [
    { value: DeviceClassification.Desktop, label: 'Desktop' },
    { value: DeviceClassification.Mobile, label: 'Mobile' },
  ];

  const update = (item: ISelectOption<DeviceClassification>) => {
    props.update(props.rulesetId, props.ruleIndex, { deviceType: item.value });
  };

  const value =
    props.rule && props.rule.deviceType
      ? items.filter(item => item.value === props.rule.deviceType).reduce((acc, item) => item, null)
      : null;

  return (
    <>
      <div data-testid="DeviceType">
        <Select
          ariaLabel="Device Type"
          label="Device Type"
          inputId="DeviceTypeSelect"
          options={items}
          value={value}
          onChange={update}
        />
      </div>
    </>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
